import React from 'react';

const ManualAddPage = React.lazy(() =>
  import('./pages/add').then((module) => ({ default: module.ManualAddPage }))
);

const ManualEditPage = React.lazy(() =>
  import('./pages/edit').then((module) => ({ default: module.ManualEditPage }))
);

const ManualTemplate = React.lazy(() =>
  import('./templates').then((module) => ({ default: module.ManualTemplate }))
);

export const manualRouting = [
  {
    path: ':channelType',
    element: <ManualTemplate />,
    children: [
      {
        index: true,
        element: <ManualAddPage />,
      },
      {
        path: ':channelId',
        children: [
          {
            index: true,
            element: <ManualEditPage />,
          },
        ],
      },
    ],
  },
];
